<template>
  <v-dialog v-model="internalValue" :width="width" persistent>
    <v-card>
      <v-card-title>
        <v-icon v-if="icon" :color="iconColor" class="mr-2">{{ icon }}</v-icon>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      
      <v-card-text>
        <v-container class="py-2">
          <slot>
            {{ message }}
          </slot>
        </v-container>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :color="cancelColor"
          :text="!cancelRaised"
          :outlined="cancelOutlined"
          @click="onCancel"
          :disabled="loading"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          :color="confirmColor"
          :text="!confirmRaised"
          :outlined="confirmOutlined"
          @click="onConfirm"
          :loading="loading"
          :disabled="loading"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseConfirmationDialog',
  
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirm Action'
    },
    message: {
      type: String,
      default: 'Are you sure you want to proceed?'
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    confirmColor: {
      type: String,
      default: 'primary darken-1'
    },
    cancelColor: {
      type: String,
      default: 'primary darken-1'
    },
    confirmRaised: {
      type: Boolean,
      default: false
    },
    cancelRaised: {
      type: Boolean,
      default: false
    },
    confirmOutlined: {
      type: Boolean,
      default: false
    },
    cancelOutlined: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: 500
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: 'warning'
    }
  },
  
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    
    onCancel() {
      this.$emit('cancel');
      this.internalValue = false;
    }
  }
};
</script>